module.exports = __webpack_public_path__ + "img/map-active-icon.55fff8cc.svg";